<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/leiloes/services'
  import BtnStatus from './BtnStatus.vue'
  import BtnStatusConfirmar from './ConfirmStatus'

  export default {
    components: {
      BtnStatus,
      BtnStatusConfirmar
    },
    nome: 'monitor-vendas-online',
    directives: {mask},
    data () {
      return {
        pendencias: null,
        pendenciasVisualizadas: []
      }
    },
    computed: {
      pendenciasFiltradas () {
        if (!this.pendencias) {
          return null
        }
        return this.pendencias.filter(p => !this.pendenciasVisualizadas.includes(p.id))
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos as informações iniciais')
      this.$interval = setInterval(() => {
        this.load()
      }, 5000)
      this.load()
    },
    beforeDestroy () {
      window.clearInterval(this.$interval)
    },
    deactivated () {
      window.clearInterval(this.$interval)
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      load () {
        service.pendenciasVendasOnline(this.$route.params.leilao)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.pendencias = response.data
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      visualizar (p) {
        this.pendenciasVisualizadas.push(p.id)
      }
    }
  }
</script>

<template>
  <div>
    <div class="wrapper-md">
      <div class="row">
        <div class="col-md-3 col-sm-6 hover-items" v-for="p in pendenciasFiltradas">
          <div class="panel wrapper">
            <h1 class="m-t-none">Lote {{ p.numero }}</h1>
            <h4 class="m-t-none">Valor Venda: R$ {{ p.valor | moeda }}</h4>
            <h4 class="m-t-none small">Valor Inicial: R$ {{ p.valorInicial | moeda }}</h4>
            <h4 class="m-t-none small">{{p.nome}}</h4>
            <h4 class="m-t-none small">{{p.apelido}}</h4>
            <a :href="'/#/website/arrematantes/' + p.arrematanteId" target="_blank">
            <span v-if="p.tipo === 1" class="btn btn-black btn-lg font-bold">CPF: {{p.cpf|formataCpf}}</span>
            <span v-else class="btn btn-black btn-lg font-bold">CNPJ: {{p.cnpj|formataCnpj}}</span>
            </a>
            <a class="btn btn-primary pull-right" @click="visualizar(p)"><i class="fa fa-eye m-r-xs"></i> Visualizei</a>
          </div>
        </div>
      </div>
      <div v-if="!pendencias || pendenciasFiltradas.length === 0">
        Nenhuma interação necessária até o momento
      </div>
      <div class="m-t" v-if="pendencias && pendencias.length > 0 && pendencias.length !== pendenciasFiltradas.length">
        <div class="m-b-xs">Você ocultou algumas pendencias por tê-las visualizado.</div>
        <a class="btn btn-primary" @click="pendenciasVisualizadas = []">Reativar pendencias ocultadas</a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// MonitorVendasOnline.vue?3c927106